import React from 'react';
import { ReviewFileCommentDbDto } from "../common/dto/ReviewFileCommentDbDto";

type Props = {
    comment: ReviewFileCommentDbDto,
    saveCommentCb: (ReviewFileCommentApiDto) => void
    closeCb: () => void
}

const CommentModal = (props: Props) => {
    const show = () => props.comment !== undefined;

    if (props.comment === undefined) {
        return null;
    }

    let text = props.comment.text;
    let isError = props.comment.isError;

    let saveComment = () => {
        props.comment.text = text;
        props.comment.isError = isError;
        props.saveCommentCb(props.comment);
        props.closeCb();
    }

    let deleteComment = () => {
        props.comment.text = '';
        props.saveCommentCb(props.comment);
        props.closeCb();
    }

    return (
        <>

        <div className={ show() ? 'modal modal-show' : 'modal' }
             tabIndex={-1} role="dialog">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <div>
                            Rida { props.comment.lineNumber } fails { props.comment.fileName }
                        </div>
                        <button type="button" className="btn-close"
                                onClick={ props.closeCb }
                                aria-label="Close" />
                    </div>
                    <div className="modal-header">
                        <label>
                            <input type="radio"
                                   name="commentType"
                                   onChange={ e => isError = e.target.value == '1' }
                                   defaultChecked={ isError } value={1} /> Viga
                        </label>
                        <label>
                            <input type="radio"
                                   name="commentType"
                                   onChange={ e => isError = e.target.value == '1' }
                                   defaultChecked={ !isError } value={0} /> Kommentaar
                        </label>
                    </div>
                    <div className="modal-body">
                        <textarea className="form-control"
                                  placeholder="Probleemi kirjeldus ..."
                                  defaultValue={ text }
                                  onChange={ e => text = e.target.value }
                                  rows={3} />
                    </div>
                    <div className="modal-footer">
                        <button type="button"
                                onClick={ () => deleteComment() }
                                className="btn btn-danger">Kustuta</button>

                        <button type="button"
                                onClick={ () => saveComment() }
                                className="btn btn-primary">Salvesta</button>
                    </div>
                </div>
            </div>
        </div>

        </>
    );

};

export default CommentModal;
